import React from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'

import { H2, P } from '@mxenabled/mxui'
import { Cardiology } from '@mxenabled/mx-icons'

import { useGlobalCopyStore } from '../../../common'

import OnboardingStepsDrawer from './OnboardingStepsDrawer'

const Onboarding = () => {
  const { finstrong: copy } = useGlobalCopyStore()

  const [isOpen, setIsOpen] = React.useState(false)

  return (
    <React.Fragment>
      <Stack
        sx={{
          alignItems: 'center',
          bgcolor: 'background.default',
          gap: 48,
          height: 'calc(100dvh - 116px)',
          pb: 24,
          pt: 72,
          px: 16,
        }}
      >
        <Stack sx={{ alignItems: { sm: 'center' }, gap: 24, width: '100%' }}>
          <Box sx={{ textAlign: 'center' }}>
            <Cardiology size={72} />
          </Box>
          <Stack sx={{ gap: 4, textAlign: 'center', width: { sm: 400 } }}>
            <H2>{copy.onboarding_title}</H2>
            <P sx={{ color: 'text.secondary' }} variant="subtitle1">
              {copy.onboarding_subtitle}
            </P>
          </Stack>
        </Stack>
        <Button onClick={() => setIsOpen(true)} variant="contained">
          {copy.onboarding_get_started}
        </Button>
      </Stack>

      <OnboardingStepsDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </React.Fragment>
  )
}

export default Onboarding
